import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import phoneIcon from "@icons/ic-phone.svg";
import addressIcon from "@icons/ic-address.svg";
import UserInfo from "@utils/UserInfo";
import {
  GenrealInfo,
  Title,
  FlexRow,
  GridRow,
  SubTitle,
  ContentInfo,
  MapContainer,
} from "./GeneralInfo.styled";
import "../../WarehouseView.scss";
import initMap from "@utils/mapSingleMarker";
import { address } from "@utils/utils";

const GeneralInfo = (props) => {
  const { t, data } = props;

  const countryId = UserInfo.countryId();
  const generalParams = useGetGeneralParameters();
  const { countryList } = generalParams;

  useEffect(() => {
    if (!!data.address.position.latitude && !!data.address.position.longitude)
      initMap(
        data.address.position.latitude,
        data.address.position.longitude,
        false
      );
  }, []);

  return (
    <>
      <GenrealInfo>
        <FlexRow column="1fr">
          <Title>{t("WAREHOUSE_GENERAL_INFORMATION")}</Title>
        </FlexRow>
        <GridRow column="1fr 1fr 1fr">
          <div>
            <FlexRow alignItems="center">
              <Image
                src={phoneIcon}
                alt={t("PHONE")}
                title={t("PHONE")}
                className="warehouse-view__communication-icon"
              />
              <SubTitle color="#767676" paddingLeft="10px">
                {data.phone !== null && data.phone !== "" ? data.phone : "-"}
              </SubTitle>
            </FlexRow>
            <FlexRow>
              <Image
                src={addressIcon}
                alt={t("ADDRESS")}
                title={t("ADDRESS")}
                className="warehouse-view__communication-icon"
              />
              <SubTitle color="#767676" paddingLeft="10px">
                <ContentInfo
                  dangerouslySetInnerHTML={{
                    __html: address(countryId, data.address, countryList),
                  }}
                ></ContentInfo>
              </SubTitle>
            </FlexRow>
          </div>
          <div>
            {!!data.address.position.latitude &&
              !!data.address.position.longitude && <MapContainer id="map" />}
          </div>
        </GridRow>
      </GenrealInfo>
    </>
  );
};
GeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(GeneralInfo);
